import { render, staticRenderFns } from "./XFWM.vue?vue&type=template&id=91fc7eda&scoped=true&"
import script from "./XFWM.vue?vue&type=script&lang=js&"
export * from "./XFWM.vue?vue&type=script&lang=js&"
import style0 from "./XFWM.vue?vue&type=style&index=0&id=91fc7eda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fc7eda",
  null
  
)

export default component.exports